export enum TransitionTargetSubsector {
  Mobility = 'mobility',
  Freight = 'freight',
  OtherTransport = 'other_transport',
  IronAndSteel = 'iron_and_steel',
  CementAndConcrete = 'cement_and_concrete',
  Refineries = 'refineries',
  PaperAndPulp = 'paper_and_pulp',
  Metals = 'metals',
  IndustryOther = 'industry_other',
  Chemical = 'chemical',
  AgriculturalLand = 'agricultural_land',
  StorageOfFertilisers = 'storage_of_fertilisers',
  AnimalDigestion = 'animal_digestion',
  ElectricityAndDistrictHeating = 'electricity_and_district_heating',
  LocalHeating = 'local_heating',
  LocalHeatingResidential = 'local_heating_residential',
  LocalCoolingResidential = 'local_cooling_residential',
  LocalCooling = 'local_cooling',
  LocalOther = 'local_other',
  LocalOtherResidential = 'local_other_residential',
  Solvents = 'solvents',
  Machinery = 'machinery',
  Waste = 'waste',
  ALL = 'ALL',
}
